import React from "react";
import "./Qualification.css";
import RedRoundBtn from "../../../Common_Btn/RedRoundBtn/RedRoundBtn";
import Mango_Color_Btn from "../../../Common_Btn/Mango_Color_Btn/Mango_Color_Btn";
import Speedometer_holder from "./Speedometer_holder/Speedometer_holder";

const Qualification = ({qualification,setQualification,...props}) => {
  return (
    <section className="Annual_Income">
      <div className="top_holder">
        <p className="step_title">Select your qualification</p>
      </div>

      <div className="scale_holder">
        <Speedometer_holder setQualification={setQualification} qualification={qualification} />
      </div>

      <div className="Continue_btn_holder">
        <RedRoundBtn
          btn_name="Continue"
          onClick={() => {
            props?.handleNext();
          }}
        />
      </div>
    </section>
  );
};

export default Qualification;
